import React, { useMemo, useRef, useState, useEffect, forwardRef, useImperativeHandle } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { uploadFile } from '../../redux/uploadFile/actionCreator.js';
import Functions from '../../utility/functions.js';
import HttpStatus from '../../utility/status.enum.js';
import { useDispatch } from 'react-redux';
import Spinner from './Spinner.js';
import '../../static/css/style.css';
import { Modal, Input, Form, Row, Col } from 'antd';
import { Button } from '../../components/buttons/buttons.js';

/* Lakhan Added code */
import { Quill } from 'react-quill';
import { BasicFormWrapper } from '../styled.js';
import { fetchCmsContent } from '../../redux/manageCms/actionCreator.js';

const Delta = Quill.import('delta');
/* Lakhan Added code */

const QuillEditor = forwardRef(({ editorValue, setValue, placeholder, handleInputChange, showDoorCodeButton = false, onDoorCodeClick }, ref) => {
  const reactQuillRef = useRef(null);
  const dispatch = useDispatch();
  const [spinnerLoader, setSpinnerLoader] = useState(false);
  const [localEditorValue, setLocalEditorValue] = useState(editorValue || '');
  const [showHtmlPreview, setShowHtmlPreview] = useState(false);
  const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);
  const [videoInput, setVideoInput] = useState('');
  const [videoInputError, setVideoInputError] = useState('');
  const [activeFormats, setActiveFormats] = useState([]);
  const [editorHelpText , setEditorHelpText] = useState()

  useEffect(() => {
    if (!editorValue || editorValue === '<p><br></p>') {
      setValue('');
    } else {
      setLocalEditorValue(editorValue);
      setValue(editorValue);
    }
  }, [editorValue]);

  useImperativeHandle(ref, () => ({
    insertTextAtCursor: (text) => {
      const quill = reactQuillRef.current.getEditor();
      if (quill) {
        let range = quill.getSelection();

        if (!range) {
          quill.focus(); // Focus the editor if not already focused
          range = quill.getSelection();
        }

        if (range) {
          quill.insertText(range.index, text); // Insert text at the cursor position
          quill.setSelection(range.index + text.length); // Move the cursor to the end of the inserted text

          // Update the local state and parent component state
          const updatedValue = quill.root.innerHTML;
          setLocalEditorValue(updatedValue); // Update internal state
          if (typeof setValue === 'function') {
            setValue(updatedValue); // Notify parent component of the change
          }
        }
      }
    },
  }));

  const insertDoorCodeVariable = () => {
    if (typeof onDoorCodeClick === 'function') {
      onDoorCodeClick('[DOOR_CODE]');
    }
  };

  const insertGuestNameVariable = () =>{
    if (typeof onDoorCodeClick === 'function') {
      onDoorCodeClick('[GUEST_FIRST_NAME]');
    }
  }

  const handleImageUpload = (quillInstance) => {
    const input = document.createElement('input');
    input.setAttribute('type', 'file');
    input.setAttribute('accept', 'image/*');
    input.style.display = 'none';

    input.addEventListener('change', async (e) => {
      const selectedFile = e.target.files[0];
      if (selectedFile) {
        try {
          const allowedTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/bmp', 'image/webp'];
          if (!allowedTypes.includes(selectedFile.type)) {
            alert('Unsupported image type. Please upload an image in JPG, PNG, GIF, BMP, or WebP format.');
            return;
          }
          const compressedFile = await Functions.compressImage(selectedFile);
          setSpinnerLoader(true);
          const formData = new FormData();
          formData.append('imageType', 5);
          formData.append('file', compressedFile);
          const uploadFileResponse = await dispatch(uploadFile(formData));
          if (uploadFileResponse?.status === HttpStatus.HTTP_OK) {
            const uploadFileResult = uploadFileResponse?.result;
            const quill = quillInstance.getEditor();
            const range = quill.getSelection(true);
            const imageUrl = uploadFileResult.filePath;

            if (range) {
              quill.insertEmbed(range.index, 'image', imageUrl);
              quill.setSelection(range.index + 1);
            } else {
              quill.insertEmbed(quill.getLength() - 1, 'image', imageUrl);
              quill.setSelection(quill.getLength() - 1);
            }

            const updatedValue = quill.root.innerHTML;
            setLocalEditorValue(updatedValue);
            if (typeof setValue === 'function') {
              setValue(updatedValue);
            }
            setSpinnerLoader(false);
          } else {
            setSpinnerLoader(false);
          }
        } catch (error) {
          setSpinnerLoader(false);
        }
      }
      document.body.removeChild(input);
    });
    document.body.appendChild(input);
    input.click();
  };

  const selectLocalImage = () => {
    handleImageUpload(reactQuillRef.current);
  };

  const toggleHtmlPreview = () => {
    setShowHtmlPreview((prevState) => !prevState);
  };

  const handleVideoUpload = () => {
    const editor = reactQuillRef.current.getEditor();
    const formats = editor.getFormat();
    setActiveFormats(Object.keys(formats));
    setVideoInput('');
    setVideoInputError('');
    setIsVideoModalOpen(true);
  };

  const closeVideoModal = () => {
    setIsVideoModalOpen(false);
    setVideoInput('');
    setVideoInputError('');
  };

  useEffect(() => {
  if (!isVideoModalOpen) return;

  const toolbar = document.querySelector(".ql-toolbar");

  const observer = new MutationObserver(() => {
    activeFormats.forEach((format) => {
      const btn = toolbar.querySelector(`.ql-${format}`);
      if (btn && !btn.classList.contains("ql-active")) {
        btn.classList.add("ql-active");
      }
    });
  });

  observer.observe(toolbar, {
    subtree: true,
    attributes: true,
    attributeFilter: ["class"],
  });

  return () => observer.disconnect();
}, [isVideoModalOpen, activeFormats]);

  const handleVideoModalSubmit = () => {
    const inputValue = (videoInput || '').trim();

    if (!inputValue) {
      setVideoInputError('Please enter video URL or embed code');
      return;
    }

    const quill = reactQuillRef.current.getEditor();
    const range = quill.getSelection(true);
    const trimmedValue = inputValue;

    const parseIframeInput = (rawValue) => {
      const srcMatch = rawValue.match(/src=(["'])(.*?)\1/i);
      const widthMatch = rawValue.match(/width=(["'])(.*?)\1/i);
      const heightMatch = rawValue.match(/height=(["'])(.*?)\1/i);

      return {
        src: srcMatch ? srcMatch[2] : '',
        width: widthMatch ? parseInt(widthMatch[2], 10) : null,
        height: heightMatch ? parseInt(heightMatch[2], 10) : null,
      };
    };

    const safeDecodeURIComponent = (value) => {
      try {
        return decodeURIComponent(value);
      } catch (error) {
        return value;
      }
    };

    const parseInstagramEmbedSnippet = (rawValue) => {
      const permalinkMatch = rawValue.match(/data-instgrm-permalink=(["'])(.*?)\1/i);
      if (permalinkMatch && permalinkMatch[2]) {
        return permalinkMatch[2].replace(/&amp;/g, '&');
      }

      const hrefMatch = rawValue.match(/href=(["'])(https?:\/\/(?:www\.)?instagram\.com\/[^"']+)\1/i);
      if (hrefMatch && hrefMatch[2]) {
        return hrefMatch[2].replace(/&amp;/g, '&');
      }

      return '';
    };

    const getInputSource = (rawValue) => {
      const isIframe = /<iframe[\s\S]*?>/i.test(rawValue);
      if (isIframe) {
        return parseIframeInput(rawValue);
      }

      const isInstagramSnippet = /<blockquote[\s\S]*instagram-media/i.test(rawValue);
      if (isInstagramSnippet) {
        const instagramPermalink = parseInstagramEmbedSnippet(rawValue);
        return { src: instagramPermalink, width: null, height: null };
      }

      return { src: rawValue, width: null, height: null };
    };

    const normalizeYouTube = (urlString) => {
      try {
        const parsed = new URL(urlString);
        const hostname = parsed.hostname.toLowerCase();
        const pathname = parsed.pathname.toLowerCase();
        let videoId = '';
        let isVertical = false;

        if (hostname.includes('youtu.be')) {
          videoId = parsed.pathname.replace('/', '').split('/')[0];
        } else if (hostname.includes('youtube.com') || hostname.includes('youtube-nocookie.com')) {
          if (pathname.startsWith('/watch')) {
            videoId = parsed.searchParams.get('v') || '';
          } else if (pathname.startsWith('/embed/')) {
            videoId = parsed.pathname.split('/embed/')[1]?.split('/')[0] || '';
          } else if (pathname.startsWith('/shorts/')) {
            videoId = parsed.pathname.split('/shorts/')[1]?.split('/')[0] || '';
            isVertical = true;
          }
        }

        if (!videoId) return null;
        return {
          provider: 'youtube',
          src: `https://www.youtube.com/embed/${videoId}`,
          isVertical,
        };
      } catch (error) {
        return null;
      }
    };

    const normalizeVimeo = (urlString) => {
      try {
        const parsed = new URL(urlString);
        const hostname = parsed.hostname.toLowerCase();
        const pathParts = parsed.pathname.split('/').filter(Boolean);
        let videoId = '';
        const isPlayerEmbedUrl = hostname.includes('player.vimeo.com');

        if (isPlayerEmbedUrl) {
          const videoIndex = pathParts.indexOf('video');
          if (videoIndex !== -1 && pathParts[videoIndex + 1]) {
            videoId = pathParts[videoIndex + 1];
          }
        } else if (hostname.includes('vimeo.com')) {
          videoId = pathParts.find((part) => /^\d+$/.test(part)) || '';
        }

        if (!videoId) return null;
        return {
          provider: 'vimeo',
          src: `https://player.vimeo.com/video/${videoId}`,
          isVertical: isPlayerEmbedUrl,
        };
      } catch (error) {
        return null;
      }
    };

    const normalizeInstagram = (urlString) => {
      try {
        const parsed = new URL(urlString);
        const hostname = parsed.hostname.toLowerCase();
        if (!hostname.includes('instagram.com')) return null;

        const pathParts = parsed.pathname.split('/').filter(Boolean);
        const contentType = (pathParts[0] || '').toLowerCase();
        const mediaId = pathParts[1] || '';

        if (!['p', 'reel', 'tv'].includes(contentType) || !mediaId) return null;
        const isVertical = contentType === 'reel' || contentType === 'tv';

        return {
          provider: 'instagram',
          src: `https://www.instagram.com/${contentType}/${mediaId}/embed`,
          isVertical,
        };
      } catch (error) {
        return null;
      }
    };

    const normalizeVideoInput = (rawValue) => {
      const sourceData = getInputSource(rawValue);
      const srcValue = sourceData.src;
      const normalizedSrc = safeDecodeURIComponent(srcValue || '').toLowerCase();

      let parsedVideo = normalizeYouTube(srcValue) || normalizeVimeo(srcValue) || normalizeInstagram(srcValue);
      if (!parsedVideo) return null;

      const hasDimensionData = Number.isFinite(sourceData.width) && Number.isFinite(sourceData.height);
      const isVerticalByRatio = hasDimensionData ? sourceData.height > sourceData.width : false;
      const isVerticalByProvider =
        parsedVideo.provider === 'youtube'
          ? /youtube\.com\/shorts\/|\/shorts\//.test(normalizedSrc) || parsedVideo.isVertical
          : parsedVideo.provider === 'instagram'
            ? /instagram\.com\/reel\/|instagram\.com\/tv\//.test(normalizedSrc) || parsedVideo.isVertical
            : Boolean(parsedVideo.isVertical);

      const isVerticalVideo = isVerticalByRatio || (!hasDimensionData && isVerticalByProvider);
      return {
        src: parsedVideo.src,
        provider: parsedVideo.provider,
        isVertical: isVerticalVideo,
      };
    };

    const withAutoplayMute = (src, provider) => {
      try {
        const embedUrl = new URL(src);
        if (provider === 'youtube') {
          embedUrl.searchParams.set('autoplay', '1');
          embedUrl.searchParams.set('mute', '1');
          embedUrl.searchParams.set('playsinline', '1');
          embedUrl.searchParams.set('rel', '0');
        } else if (provider === 'vimeo') {
          embedUrl.searchParams.set('autoplay', '1');
          embedUrl.searchParams.set('muted', '1');
          embedUrl.searchParams.set('autopause', '0');
        } else if (provider === 'instagram') {
          // Best-effort: Instagram may ignore autoplay params depending on platform restrictions.
          embedUrl.searchParams.set('autoplay', '1');
          embedUrl.searchParams.set('muted', '1');
        }
        return embedUrl.toString();
      } catch (error) {
        return src;
      }
    };

    const normalizedVideo = normalizeVideoInput(trimmedValue);
    if (!normalizedVideo) {
      setVideoInputError('Please enter a valid YouTube, Vimeo, or Instagram URL, or a valid iframe embed code');
      return;
    }

    const embedSrc = withAutoplayMute(normalizedVideo.src, normalizedVideo.provider);
    const verticalWidth = 315;
    const verticalHeight = 560;
    const embedCode = normalizedVideo.isVertical
      ? `<iframe src="${embedSrc}" width="${verticalWidth}" height="${verticalHeight}" frameborder="0" allow="autoplay; fullscreen; encrypted-media" allowfullscreen></iframe>`
      : `<iframe src="${embedSrc}" frameborder="0" allow="autoplay; fullscreen; encrypted-media" allowfullscreen></iframe>`;

    if (range) {
      quill.clipboard.dangerouslyPasteHTML(range.index, embedCode);
      quill.setSelection(range.index + 1);
    } else {
      quill.clipboard.dangerouslyPasteHTML(quill.getLength(), embedCode);
      quill.setSelection(quill.getLength() + 1);
    }

    const updatedValue = quill.root.innerHTML;
    setLocalEditorValue(updatedValue);
    if (typeof setValue === 'function') {
      setValue(updatedValue);
    }

    closeVideoModal();
  };

  const modules = useMemo(() => {
    const actionButtons = showDoorCodeButton
      ? ['bold', 'italic', 'underline', 'doorcode','guestname', 'video','image','link' ]
      : ['bold', 'italic', 'underline','video', 'image','link'];

    return {
      toolbar: {
        container: [[{ header: [1, 2, false] }], actionButtons],
        handlers: {
          image: selectLocalImage,
          video: handleVideoUpload,
          doorcode: insertDoorCodeVariable,
          guestname:insertGuestNameVariable
        },
      },
    };
  }, [showDoorCodeButton]);

  useEffect(() => {
    if (reactQuillRef.current) {
      const toolbar = reactQuillRef.current.getEditor().getModule('toolbar');
      if (toolbar?.addHandler) {
        toolbar.addHandler('html-preview', toggleHtmlPreview);
      }
    }
  }, []);

  const handleEditorOnChange = (content, delta, source, editor) => {
    const editorValues = editor.getHTML();
    const updatedValue = editorValues;

    if (source === 'user') {
      if (!updatedValue || updatedValue === '<p><br></p>') {
        setLocalEditorValue('');
        handleInputChange();
      } else {
        handleInputChange();
        setLocalEditorValue(updatedValue);
      }
      if (typeof setValue === 'function') {
        if (!updatedValue || updatedValue === '<p><br></p>') {
          setValue('');
        } else {
          setValue(updatedValue);
        }
      }
    }
  };

  /* Lakhan Patat Added */
  // MutationObserver to check for changes
  useEffect(() => {
    const quill = reactQuillRef.current.getEditor();
    const observer = new MutationObserver(() => {
      const content = quill.root.innerHTML;
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = content;
      const links = tempDiv.querySelectorAll('a');
      links.forEach(link => {
        let href = link.getAttribute('href');
        if (href && !/^https?:\/\//i.test(href)) {
          link.setAttribute('href', 'http://' + href);
        }
      });
      const updatedContent = tempDiv.innerHTML;
      if (content !== updatedContent) {
        quill.root.innerHTML = updatedContent; // Update the content
      }
    });
    observer.observe(quill.root, {
      childList: true,
      subtree: true,
    });

    return () => {
      observer.disconnect();
    };
  }, []);

  // Using this UseEffect we can detect if the current pasted content is from BE(API) and User pasted 
  // Based on the condition we are applying the Formatting
  useEffect(() => {
    const quill = reactQuillRef.current?.getEditor();
  if (!quill) return;

  // ---- PASTE-ONLY MATCHER (NOT GLOBAL) ----
  const handlePaste = () => {
    const range = quill.getSelection(true);
    if (!range) return;

    //  Remove selected content (Ctrl+A or partial)
    if (range.length > 0) {
      quill.deleteText(range.index, range.length, 'silent');
    }

    //  Find current line & its start
    const [line, offset] = quill.getLine(range.index);
    if (!line) return;

    const lineStart = range.index - offset;

    //  Force line to be NORMAL paragraph (kills H1/H2)
    quill.formatLine(lineStart, 1, {
      header: false,
      list: false,
      blockquote: false,
      codeBlock: false
    }, 'silent');

    quill.clipboard.addMatcher(Node.ELEMENT_NODE, pasteMatcher);
    // Clear inline formats at cursor
    // quill.removeFormat(range.index, 1, 'silent');
    setTimeout(() => {
      const sel = quill.getSelection();
      if (!sel) return;

      quill.removeFormat(sel.index - 1, 1, 'user');

      // Remove matcher immediately (VERY IMPORTANT)
      quill.clipboard.matchers =
        quill.clipboard.matchers.filter(m => m[1] !== pasteMatcher);
    }, 0);

    // Restore cursor (important)
    quill.setSelection(range.index, 0, 'silent');
  };

  const pasteMatcher = (node, delta) => {
    if (node.tagName === 'IFRAME') {
      return delta;
    }
    const cleanOps = [];

    delta.ops.forEach(op => {
      // Keep images
      if (op.insert && op.insert.image) {
        cleanOps.push(op);
        return;
      }
      // keep video(iframe) as it is
      if (op.insert && op.insert.video) {
        cleanOps.push(op);
        return;
      }

      // Keep link but ONLY href
      if (typeof op.insert === 'string' && op.attributes?.link) {
        cleanOps.push({
          insert: op.insert,
          attributes: { link: op.attributes.link }
        });
        return;
      }

      // Plain text (no formatting)
      if (typeof op.insert === 'string') {
        cleanOps.push({ insert: op.insert });
      }
    });

    delta.ops = cleanOps;
    return delta;
  };

  quill.root.addEventListener('paste', handlePaste, true);

  return () => {
    quill.root.removeEventListener('paste', handlePaste, true);
  };
  }, []);

  // CopyHandler add just to keep the href link to be as it is 
  useEffect(() => {
    const quill = reactQuillRef.current?.getEditor();
    if (!quill) return;

    const root = quill.root;
    const handleCopy = (e) => {
      const selection = window.getSelection();
      if (!selection || selection.rangeCount === 0) return;

      if (!root.contains(selection.anchorNode)) return;

      const container = document.createElement('div');
      container.appendChild(selection.getRangeAt(0).cloneContents());

      // Fix href using data-raw-href
      container.querySelectorAll('a').forEach(link => {
        const raw = link.getAttribute('data-raw-href');
        if (raw) link.setAttribute('href', raw);
      });

      e.preventDefault();
      e.clipboardData.setData('text/html', container.innerHTML);
      e.clipboardData.setData('text/plain', selection.toString());
    };

    root.addEventListener('copy', handleCopy);
    return () => root.removeEventListener('copy', handleCopy);
  }, []);

  // Detect the href and override the raw url
  useEffect(() => {
    const quill = reactQuillRef.current?.getEditor();
    if (!quill) return;

    const clipboard = quill.getModule('clipboard');

    clipboard.addMatcher('A', (node, delta) => {
      // Use raw URL from data-raw-href
      const raw = node.getAttribute('data-raw-href') || node.getAttribute('href');

      delta.ops.forEach(op => {
        if (op.attributes?.link) {
          op.attributes.link = raw; // override with raw URL
        }
      });

      return delta;
    });
  }, []);
  
  useEffect(() => {
    const quill = reactQuillRef.current?.getEditor();
    if (!quill) return;

    const tooltip = quill.theme?.tooltip?.root;
    const container = quill.container; // The actual editor element
    if (!tooltip || !container) return;

    const adjustTooltip = () => {
      requestAnimationFrame(() => {
        const tooltipRect = tooltip.getBoundingClientRect();
        const containerRect = container.getBoundingClientRect();

        // 1. Horizontal Constraint (Left/Right)
        let currentLeft = parseFloat(tooltip.style.left);
        
        // If tooltip goes past the right edge
        if (tooltipRect.right > containerRect.right) {
          const overflowX = tooltipRect.right - containerRect.right;
          tooltip.style.left = `${currentLeft - overflowX - 10}px`; // 10px padding
        }
        
        // If tooltip goes past the left edge
        if (tooltipRect.left < containerRect.left) {
          tooltip.style.left = '0px';
        }

        // 2. Vertical Constraint (Top/Bottom)
        let currentTop = parseFloat(tooltip.style.top);

        // If tooltip goes above the top (often happens with 'ql-flip')
        if (tooltipRect.top < containerRect.top) {
          tooltip.style.top = '10px'; 
        }

        // If tooltip goes below the bottom (causing vertical scroll)
        if (tooltipRect.bottom > containerRect.bottom) {
          const overflowY = tooltipRect.bottom - containerRect.bottom;
          tooltip.style.top = `${currentTop - overflowY - 5}px`;
        }
      });
    };

    quill.on('selection-change', adjustTooltip);
    // Also listen for text-change in case editing the link moves the tooltip
    quill.on('text-change', adjustTooltip); 

    return () => {
      quill.off('selection-change', adjustTooltip);
      quill.off('text-change', adjustTooltip);
    };
  }, []);

  const handleLinkClick = (event) => {
    event.stopPropagation();
    event.preventDefault();
  };

  const showEarlyCheckingInfo = (actionType) => {

    const fetchCmsContentData = async () => {
      try {
        const fetchCmsContentResponse = await dispatch(
          fetchCmsContent({
            action_type: actionType,
          }),
        );
        if (fetchCmsContentResponse.status === HttpStatus.HTTP_OK) {
          const resultData = fetchCmsContentResponse?.result?.description;
          const hasIntercomArticleId = Functions.findIntercomArticleId(resultData); // Check if CMS content has an Intercom ID
          if (!hasIntercomArticleId) {
              setEditorHelpText(resultData);
          }
        }
      } catch (error) { }
    }
    fetchCmsContentData();
  }

  /* Lakhan Patat Added */
  return (
    <div className="customEditor">
      {spinnerLoader && <Spinner loader={spinnerLoader} />}
      <ReactQuill
        ref={reactQuillRef}
        value={localEditorValue}
        onChange={handleEditorOnChange}
        modules={modules}
        placeholder={placeholder}
      />
      <Modal
        title="Add Video"
        open={isVideoModalOpen}
        onCancel={closeVideoModal}
        footer={null}
        className="modal-md"
        maskClosable={false}
      >
        <div className="project-modal">
          <BasicFormWrapper>
          <Form onFinish={handleVideoModalSubmit}>
            <Row gutter={15}>
              <Col xs={24} md={24}>
                <div className="project-modal">
                  <Form.Item
                    label={
                        <span>
                          <span
                            onClick={(event) => {
                            }}
                          >
                           Video URL / Embed Code{' '}(🛎️
                          </span>
                          <a
                            className="common_urlLink"
                            onClick={(event) => {
                              showEarlyCheckingInfo(34);
                              handleLinkClick(event);
                            }}
                          >
                            Help please!
                          </a>
                            )
                        </span>
                      }
                   className="custom_input_style">
                    <Input.TextArea
                      id="quill-video-input"
                      placeholder="Paste video URL or embed code, click article pop up for more info"
                      value={videoInput}
                      onChange={(e) => {
                        setVideoInput(e.target.value);
                        if (videoInputError) {
                          setVideoInputError('');
                        }
                      }}
                      autoSize={{ minRows: 3, maxRows: 6 }}
                    />
                    {videoInputError && (
                      <div className="showImageError">
                        <div className="ant-form-item-has-error ant-form-item-explain-error">
                          {videoInputError}
                        </div>
                      </div>
                    )}
                  </Form.Item>
                </div>
              </Col>
            </Row>
            <Row gutter={15} className="mt-20">
              <Col xs={24}>
                <Button htmlType="submit" size="default" type="dark" shape="circle" className="w-100">
                  Save
                </Button>
              </Col>
            </Row>
          </Form>
          </BasicFormWrapper>
        </div>
      </Modal>

      <Modal
        type='primary'
        visible={editorHelpText}
        footer={null}
        onCancel={() => setEditorHelpText(false)}
        className="modal-md"
        maskClosable={false}
        aria-hidden="false"
      >
        <div className="Idmodalbox earlyCheckinPopup">
          <div className="hostPayout">

            <div className="modal-content" dangerouslySetInnerHTML={{ __html: editorHelpText }} />
          </div>
        </div>
      </Modal>
    </div>
  );
});

export default QuillEditor;
